<template>
  <div>
    <!-- {{filterPayload}} -->
    <!-- <pre>{{studentAttendanceList}}</pre> -->
    <vs-card class="cstm_vx_card">
      <div slot="header">
        <h4 v-if="!$route.params.clientObject">All Students List</h4>
      </div>

      <div
        slot="header"
        class="flex items-center mb-4"
        v-if="$route && $route.params && $route.params.clientObject"
      >
      <vs-button type="border"
        @click="$router.push({name:'attendance'}).catch(()=>{})" icon="chevron_left"
        ></vs-button>
        <!-- {{$route.params}} -->
        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-if="$route.params.clientObject.picture"
          :src="$route.params.clientObject.picture"
          alt="image"
        />
        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-else
          src="http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png"
          alt="image"
        />
        <a style="font-weight: 600" class="ml-2">
          <!-- asdadasdasdad -->
          <span v-if="$route.params.clientObject.first_name">{{ $route.params.clientObject.first_name }} </span>
          <span v-if="$route.params.clientObject.middle_name">{{ $route.params.clientObject.middle_name }} </span>
          <span v-if="$route.params.clientObject.last_name">{{ $route.params.clientObject.last_name }}</span>
        </a>
      </div>
      
      <ag-grid-vue 
        ref="agGridTable"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :style="{ minHeight: studentAttendanceList.length * 48 + 75 + 'px' }"
        :gridOptions="gridOptions"
        :animateRows="true"
        :floatingFilter="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :columnDefs="studentAttendanceListColumnDefs"
        :rowData="studentAttendanceList"
        @grid-ready="onGridReady"
      />
    </vs-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import AttendanceNameCell from '../table_components/AttendanceNameCell.vue'
import AttendanceCell from '../table_components/AttendanceCell.vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { attendanceMixin } from '../mixins/attendanceMixin'
import {
  fetchSingleAttendanceHistoryApi,
  setAttendanceApi
} from '@/api/attendance'

export default {
  mixins: [attendanceMixin, PermissionMiddleware],
  props: {
    filterPayload: {
      type: Object,
      required: true
    }
  },
  components: {
    AgGridVue,
    AttendanceNameCell,
    AttendanceCell
  },
  data () {
    return {
      gridOptions: {},
      gridApi: null,
      studentAttendanceList: [],
      studentAttendanceListColumnDefs: []
    }
  },
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Attendance')
    }
    this.fetchSingle()
  },
  mounted () {
    if (!this.$route.params.clientObject) {
      this.studentAttendanceListColumnDefs.push(
        {
          headerName: 'Student Name',
          field: 'student_name',
          cellRendererFramework: Vue.extend(AttendanceNameCell)
        }
      )
    }

    this.studentAttendanceListColumnDefs.push(
      {
        headerName: 'Course Name',
        field: 'course_name'
      },
      {
        headerName: 'Teacher Name',
        field: 'teacher_name'
      },
      {
        headerName: 'Date',
        field: 'schedule_date',
        // eslint-disable-next-line no-confusing-arrow
        valueFormatter: params => this.$route.params.clientObject ? this.$options.filters.dateFormatLocalization(params.data.schedule_date) : this.$options.filters.dateFormatLocalization(params.data.start_date)
      }
    )

    if (this.checkViewPermission()) {
      this.studentAttendanceListColumnDefs.push(
        {
          headerName: 'Attendance',
          field: 'attendance',
          cellRendererFramework: Vue.extend(AttendanceCell),
          CellRendererParams: {
            leavingMouse: (data) => this.leavingMouse(data),
            //edit_permission: () => this.edit_permission(),
            markingAttendance: (a, b, c, d) => this.markingAttendance(a, b, c, d),
            editAttendance: (data) => this.editAttendance(data),
            checkMarkAttendanceModule: () => this.checkMarkAttendanceModule(),
            isStudentList: true
          }
        }
      )
    }
  },
  methods: {
    leavingMouse (attendanceInfo) {
      // console.log(attendanceInfo)
      if (
        typeof attendanceInfo.attendance === 'boolean' &&
        !attendanceInfo.attendance_marked
      ) {
        // console.log('hi')
        attendanceInfo.attendance_marked = true
      }
      console.log(attendanceInfo)
    },
    presenCheck () {
      console.log('hi')
    },
    editAttendance (attendanceInfo) {
      console.log(attendanceInfo)
      attendanceInfo.attendance_marked = false
      /* indextr.attendance = ''
      indextr.delayed_num = null
      indextr.delayed_input = true */
    },
    delayedFunc (index) {
      console.log('hi enter')
      index.delayed_input = false
    },
    async fetchSingle () {
      try {
        this.$vs.loading({ text: 'Fetching Attendance List' })
        const payload = {
          start_date: this.$moment(this.filterPayload.start_date).format(
            'YYYY-MM-DD'
          ),
          end_date: this.$moment(this.filterPayload.end_date).format(
            'YYYY-MM-DD'
          ),
          course_id: this.filterPayload.course_id,
          client_user_id: this.filterPayload.client_user_id || null,
          search: this.filterPayload.search || ''
        }
        const customer_id = localStorage.getItem('customer_id')
        const { data } = await fetchSingleAttendanceHistoryApi(
          customer_id,
          payload
        )
        console.log(data)
        this.mergeAttendace(data.data.students, data.data.attendance)

        // this.structuredStandardList(attendanceList)
        //
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    mergeAttendace (studentList, attendance) {

      const alreadyAttendanceGiven = attendance.map((ele) => {
        return {
          ...ele,
          attendance_id: ele.id,
          attendance_marked: true,
          schedule_date:this.$moment(ele.attendance_date).format('YYYY-MM-DD')
        }
      })

      let notGiven = []
      console.log(this.$route.params.clientObject)
      //checking for singleStudent And If Single Student Is there then need to do the client Side 
      if (!this.$route.params.clientObject) {
        /* console.log('here now ----')
        console.log('AG', alreadyAttendanceGiven)
        console.log('SL', studentList) */

        studentList.forEach(item => {
          const foundItems = alreadyAttendanceGiven.filter(ele => {
            return item.schedule_date.includes(ele.attendance_date) && item.course_id === ele.course_id && item.client_user_id === ele.client_user_id
          })

          //console.log(foundItems)

          if (foundItems.length < 1) {
            notGiven.push({
              ...item,
              attendance_id: null,
              attendance: null,
              delay_in_minutes: null,
              attendance_marked: false
            })
          }
        })

        //console.log('NG', notGiven)

        /* notGiven = studentList.map((ele) => {
          return {
            ...ele,
            attendance_id: null,
            attendance: null,
            delay_in_minutes: null,
            attendance_marked: false
          }
        }) */
      } else {
        notGiven = this.eachStudentNotMarkedData(studentList, attendance).map((ele) => {
          return {
            ...ele,
            attendance_id: null,
            attendance: null,
            delay_in_minutes: null,
            attendance_marked: false
          }
        })
      }

      if (this.filterPayload.attendance_type === 'Marked') {
        this.studentAttendanceList = [...alreadyAttendanceGiven]
      } else if (this.filterPayload.attendance_type === 'UnMarked') {
        this.studentAttendanceList = [...notGiven]

      } else {
        this.studentAttendanceList = [...alreadyAttendanceGiven, ...notGiven]

      }
      /* this.studentAttendanceList = [...alreadyAttendanceGiven, ...notGiven]
      console.log(this.studentAttendanceList) */
    },
    eachStudentNotMarkedData (studentList, attendanceList) {
      const student = []
      const attendanceGivenCombination = attendanceList.map(ele => {
        return `${ele.client_user_id}${ele.course_id}${this.$moment(ele.attendance_date).format('YYYY-MM-DD')}`        
      })
      studentList.forEach(ele => {
        ele.schedule_date.forEach(eachScheduleDate => {
          const stringChecking = `${ele.client_user_id}${ele.course_id}${this.$moment(eachScheduleDate).format('YYYY-MM-DD')}`   
          // if (this.$moment(this.$moment(eachScheduleDate).format('YYYY-MM-DD')).isBetween(
          //   this.$moment(this.filterPayload.start_date).format('YYYY-MM-DD'), this.$moment(this.filterPayload.end_date).format('YYYY-MM-DD'))) {
          //   if (!attendanceGivenCombination.includes(stringChecking)) {
          //     student.push({...ele, schedule_date:eachScheduleDate})
          //   }
          // }
          if (!attendanceGivenCombination.includes(stringChecking)) {
            student.push({...ele, schedule_date:eachScheduleDate})
          }
        })
        // true

      })
      // console.log(student)

      return student

    },
    async structuredStandardList (studentList) {
      return studentList.map((ele) => {
        return {
          attendance_id: null,
          id: ele.client_user_id,
          attendance: true,
          delay_in_minutes: 0,
          name: `${ele.first_name} ${ele.last_name}`,
          picture: `${ele.picture}`
        }
      })
    },
    markingAttendance (attendance, attendanceObject, type, event) {
      console.log(attendanceObject)
      console.log(event)
      const payload = {
        course_id: attendanceObject.course_id,
        attendance_date: this.$route.params.clientObject ? attendanceObject.schedule_date : this.filterPayload.start_date,
        client_user_id: attendanceObject.client_user_id,
        attendance: attendanceObject.attendance,
        delay_in_minutes: attendanceObject.delay_in_minutes
      }
      console.log(attendance)
      console.log(payload)

     
      if (type === 'delayed') {

        if (attendanceObject.delay_in_minutes > 1 && attendanceObject.delay_in_minutes <= 120) {
          if (
            event &&
        'keyCode' in event &&
        event.keyCode === 13 &&
        type === 'delayed'
          ) {
            attendanceObject.attendance_marked = true
          }
          this.submitAttendance(payload)

        } else {
          this.showSuccessMessage('Error', 'Attendance must be between 1 And 120', 'danger')
        }
         
      } else {
        this.submitAttendance(payload)

      }
    },
    async submitAttendance (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const data = await setAttendanceApi(customer_id, payload)
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  },
  directives: {},
  watch: {
    filterPayload: {
      deep: true,
      handler () {
        console.log(this.filterPayload)
        // this.fetchSingle()
        console.log(this.filterPayload)
        this.fetchSingle()
      }
    }
    /* 'studentAttendanceList' :  {
      deep:true,
      handler (value) {
        console.log(value) 
      }
      
    } */
  }
}
</script>

<style lang="scss" scoped>
</style>